import * as GoldenLayout from 'golden-layout';
/**
 * \@whatItDoes Lifecycle hook that is called after a component has been created
 * @abstract
 */
export abstract class GlOnInit {
/**
 * @abstract
 * @param {?} eventHub
 * @param {?} componentState
 * @return {?}
 */
glOnInit(eventHub: GoldenLayout.EventEmitter, componentState: any) {}
}
/**
 * \@whatItDoes Hook that is called after a component has been resized.
 * @abstract
 */
export abstract class GlOnResize {
/**
 * @abstract
 * @return {?}
 */
glOnResize() {}
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
